<div class="markdown-body" [innerHTML]="rendered()"></div>
